"use client";
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";

export default function Providers({ 
  children,
  params
}: { 
  children: React.ReactNode,
  params: { lang: string }
}) {
  const lang = params.lang || 'en-US';

  return (
    <ContentfulLivePreviewProvider 
      	  locale={lang} 
          enableInspectorMode={true}
          enableLiveUpdates={true}
      >
      {children}
    </ContentfulLivePreviewProvider>
  );
}